







// Import vendors ----------------------------------------------------------------------------------
import { defineComponent, computed } from '@vue/composition-api';

export default defineComponent({
  name: 'ElementChipNormValue',
  props: {
    value: {
      type: [Number, String],
      required: true
    },
    indicator: {
      type: String || null
    },
    unit: {
      type: String,
      required: false,
      default: ''
    },
    simple: {
      type: Boolean,
      default: false
    }
  },
  setup(properties) {
    const myIndicator = computed(() => {
      if (properties.indicator === null || properties.indicator === undefined) {
        return 'default';
      }
      return properties.indicator;
    });
    return { myIndicator };
  }
});
